import Plyr from '../../../assets/custom_components/plyr/plyr'

/* @ngInject */
function AuditSocialMediaCarouselController ($scope, $attrs, $window, $translate, $timeout, $q, SocialMediaService, UdsModalService) {
  const getSocialMediaNonConformityController = () => $q.when(import('../../dialogs/social-media/non-conformity/non-conformity.controller'))

  const autoTransitionId = null

  const previousDirection = -1
  const nextDirection = 1

  const socialType = 'instagram'

  const api = {
    getSocialMediaNonConformityController,
    _createCarousel,
    _renderSlides,
    _setActiveSlide,
    _setActiveDot,
    _goToSlide,
    _navigate,
    _setupArrows,
    _setupDots,
    _setupSwipeEvents,
    _setupAutoTransition,
    _toggleArrows,
    _initializePlyrVideo,
    _mountImageSlide,
    _mountVideoSlide,
    _addAssetUrlToSlides
  }

  $scope.currentIndex = 0
  $scope.slides = []

  this.getApi = () => api

  activate()

  function activate () {
    const container = $attrs.$$element.find('.audit-social-media-carousel__container')[0]

    const config = {
      infinite: false,
      dots: true,
      arrows: true,
      autoTransition: false,
      autoTransitionDelay: 3000
    }

    $scope.post = api._addAssetUrlToSlides($scope.post)
    $scope.slides = $scope.post.carouselContents

    api._createCarousel($scope.slides, config, container)
  }

  $scope.openLink = (link) => {
    $window.open(link, '_blank', 'noopener noreferrer')
  }

  $scope.onReport = (post) => {
    api.getSocialMediaNonConformityController().then(({ SocialMediaNonConformityController }) => {
      const socialMediaNonConformityDialog = UdsModalService.createModal({
        controller: SocialMediaNonConformityController,
        modalName: 'socialMediaNonConformityDialog',
        data: {
          reportType: 'post',
          ...post
        }
      })
      socialMediaNonConformityDialog.open()
    })
  }

  function _createCarousel (slides, config, container = document.body) {
    const swipe = {
      active: false,
      threshold: 75,
      offset: 0
    }

    const classNames = {
      wrapper: 'audit-social-media-carousel__wrapper',
      slide: 'audit-social-media-carousel__slide',
      active: 'audit-social-media-carousel__slide--active',
      navigation: {
        dots: 'audit-social-media-carousel__dots',
        arrows: 'audit-social-media-carousel__arrows',
        leftArrow: 'audit-social-media-carousel__leftArrow',
        rightArrow: 'audit-social-media-carousel__rightArrow'
      }
    }

    const wrapper = document.createElement('div')
    wrapper.classList.add(classNames.wrapper)
    container.append(wrapper)

    // initialize carousel
    api._renderSlides(classNames, wrapper)
    api._setupArrows(config, classNames, wrapper)
    api._setupDots(config, classNames, wrapper)
    api._setupSwipeEvents(config, classNames, wrapper, autoTransitionId, swipe)
    api._setupAutoTransition(config, classNames, wrapper, autoTransitionId)
    api._toggleArrows(config, classNames, wrapper, $scope.currentIndex)
  }

  function _renderSlides (classNames, wrapper) {
    $scope.slides.forEach((slide, index) => {
      const slideEl = document.createElement('div')

      slideEl.classList.add(classNames.slide)
      slideEl.setAttribute('data-slide', index)

      if (index === 0) {
        slideEl.classList.add(classNames.active)
      }

      const slideTypes = {
        IMAGE: () => api._mountImageSlide(slideEl, slide),
        VIDEO: () => api._mountVideoSlide(slideEl, slide)
      }

      const slideType = slideTypes[slide.mediaType]

      if (slideType) {
        slideType()
      }

      wrapper.appendChild(slideEl)
    })
  }

  function _setActiveSlide (classNames, wrapper, index) {
    [...wrapper.children].forEach((child) => {
      if (child.classList.contains(classNames.slide)) {
        child.classList.toggle(
          classNames.active,
          +child.dataset.slide === index
        )
      }
    })
  }

  function _setActiveDot (classNames, wrapper, index) {
    const dotsContainer = wrapper.querySelector(`.${classNames.navigation.dots}`)
    if (!dotsContainer) return;

    [...dotsContainer.children].forEach((dot, dotIndex) => {
      dot.classList.toggle(classNames.active, dotIndex === index)
    })
  }

  function _goToSlide (config, classNames, wrapper, index) {
    $scope.currentIndex = index

    api._setActiveSlide(classNames, wrapper, $scope.currentIndex)
    api._setActiveDot(classNames, wrapper, $scope.currentIndex)
    api._toggleArrows(config, classNames, wrapper, $scope.currentIndex)
  }

  function _navigate (config, classNames, wrapper, direction) {
    if (config.infinite) {
      $scope.currentIndex = ($scope.currentIndex + direction + $scope.slides.length) % $scope.slides.length
    } else {
      const nextIndex = $scope.currentIndex + direction
      if (nextIndex >= 0 && nextIndex < $scope.slides.length) {
        $scope.currentIndex = nextIndex
      }
    }

    api._setActiveSlide(classNames, wrapper, $scope.currentIndex)
    api._setActiveDot(classNames, wrapper, $scope.currentIndex)
    api._toggleArrows(config, classNames, wrapper, $scope.currentIndex)
  }

  function _setupArrows (config, classNames, wrapper) {
    if (!config.arrows) return

    const chevronRight = '<uds-icon name="chevron-right" size="md" icon-color="neutralColorHighPure"></uds-icon>'
    const chevronLeft = '<uds-icon name="chevron-left" size="md" icon-color="neutralColorHighPure"></uds-icon>'

    const arrows = [
      {
        icon: chevronLeft,
        className: classNames.navigation.leftArrow,
        label: $translate.instant('goBack'),
        action: () => api._navigate(config, classNames, wrapper, previousDirection)
      },
      {
        icon: chevronRight,
        className: classNames.navigation.rightArrow,
        label: $translate.instant('next'),
        action: () => api._navigate(config, classNames, wrapper, nextDirection)
      }
    ]

    arrows.forEach(({ icon, className, label, action }) => {
      const button = document.createElement('button')
      button.className = `${classNames.navigation.arrows} ${className}`
      button.innerHTML = icon
      button.title = label
      button.addEventListener('pointerdown', action)
      wrapper.appendChild(button)
    })
  }

  function _setupDots (config, classNames, wrapper) {
    if (!config.dots) return

    const dotsContainer = document.createElement('div')
    dotsContainer.className = classNames.navigation.dots

    $scope.slides.forEach((slide, index) => {
      const currentSlideIndex = index + 1
      const title = `${$translate.instant('socialMedia.feed')} ${currentSlideIndex}`
      const dot = document.createElement('button')

      dot.title = title

      if (index === $scope.currentIndex) {
        dot.classList.add(classNames.active)
      }

      dot.addEventListener('pointerdown', () => api._goToSlide(config, classNames, wrapper, index))
      dotsContainer.appendChild(dot)
    })

    wrapper.appendChild(dotsContainer)
  }

  function _setupSwipeEvents (config, classNames, wrapper, autoTransitionId, swipe) {
    wrapper.addEventListener('pointerdown', (event) => {
      clearInterval(autoTransitionId)
      swipe.active = true
      swipe.offset = event.clientX
    })

    wrapper.addEventListener('pointerup', (event) => {
      if (!swipe.active) return

      swipe.active = false

      const delta = event.clientX - swipe.offset

      if (Math.abs(delta) >= swipe.threshold) {
        const direction = delta < 0 ? nextDirection : previousDirection
        api._navigate(config, classNames, wrapper, direction)
      }
    })
  }

  function _setupAutoTransition (config, classNames, wrapper, autoTransitionId) {
    if (!config.autoTransition) return

    const navigate = () => api._navigate(config, classNames, wrapper, nextDirection)
    const delay = config.autoTransitionDelay || 3000

    autoTransitionId = setInterval(navigate, delay)
  }

  function _toggleArrows (config, className, wrapper, currentIndex) {
    if (config.infinite) return

    const leftArrow = wrapper.querySelector(`.${className.navigation.leftArrow}`)
    const rightArrow = wrapper.querySelector(`.${className.navigation.rightArrow}`)

    const isFirstSlide = currentIndex === 0
    const isLastSlide = currentIndex === $scope.slides.length - 1

    if (isFirstSlide) {
      leftArrow.classList.add('hidden')
    } else {
      leftArrow.classList.remove('hidden')
    }

    if (isLastSlide) {
      rightArrow.classList.toggle('hidden')
    } else {
      rightArrow.classList.remove('hidden')
    }
  }

  function _initializePlyrVideo (src) {
    const controls = [
      'play',
      'mute',
      'progress',
      'duration'
    ]

    const playerElement = $attrs.$$element.find('.preview__video')[0]
    const player = new Plyr(playerElement, { controls })

    player.source = {
      type: 'video',
      sources: [
        {
          src,
          type: 'video/mp4'
        }
      ]
    }
  }

  function _mountImageSlide (slideEl, slide) {
    const image = document.createElement('img')
    image.src = slide.assetUrl
    image.loading = 'lazy'
    image.width = '100%'
    image.classList.add('preview__image')
    slideEl.appendChild(image)
  }

  function _mountVideoSlide (slideEl, slide) {
    const video = document.createElement('video')
    video.src = slide.assetUrl
    video.controls = true
    video.classList.add('preview__video')

    slideEl.appendChild(video)

    $timeout(() => {
      api._initializePlyrVideo(slide.assetUrl)
    }, 300, false)
  }

  function _addAssetUrlToSlides (post) {
    const carouselContents = post.carouselContents.map(slide => ({
      ...slide,
      assetUrl: SocialMediaService.getContentAsset(socialType, slide.id)
    }))

    return {
      ...post,
      carouselContents
    }
  }
}

export { AuditSocialMediaCarouselController }
